import type { IconSvgObject } from './types';

const GoForward10SecIcon: IconSvgObject = [
  ["path", { d: "M12 5L14 2.20004C13.3538 2.06886 12.6849 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 8.72836 20.4289 5.82368 18 3.99927", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 15.5V9.5L7.5 10.5M12 10.5V14.5C12 15.0523 12.4477 15.5 13 15.5H14.5C15.0522 15.5 15.5 15.0523 15.5 14.5V10.5C15.5 9.94772 15.0522 9.5 14.5 9.5L13 9.5C12.4477 9.5 12 9.94772 12 10.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default GoForward10SecIcon;
